 import React, {useEffect, useState, useContext} from 'react'
 import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { FaRegEdit } from "react-icons/fa";
import { RiDeleteBin5Line } from "react-icons/ri";
import Form from 'react-bootstrap/Form';
import Contex from '../Context/CreateContext';
import { Link } from "react-router-dom";
const Experience = () => {
  const token  = localStorage.getItem('at')
   const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
    const contex = useContext(Contex);
  const {  ExperienceData,fetchExperienceData,  updateExperience, handleDeleteExperience, showAlert} = contex;
  
    useEffect(() => {
      (async () => {
     await fetchExperienceData();
      
})();
   
    }, [ ])
    
 

// const [ExperienceData, setExperienceData] = useState([])

const [fetchedData, setFetchedData] = useState({id:"", ejob: "",edepartment: "", eInstitute: "", edate:""})
    //  😃 update experience
    //  onclick edit experience
const handleEdit = async(data) =>{
  handleShow();
  setFetchedData({id:data.id, ejob:data.job,edepartment:data.department, eInstitute:data.institute, edate:data.date})
 
  // setExperienceData(data);
 
}
       // update  changes in experience data
 const handleUpdate =async()=>{
 
  const res = await   updateExperience({
    id:fetchedData.id,
    job:fetchedData.ejob,
    department:fetchedData.edepartment,
    institute:fetchedData.eInstitute,
     date:fetchedData.edate
  });
  const json = await  res.json()
 
  
   if (!res.ok) {
     handleClose()
      showAlert("danger", json.msg)
     
   }else{
     handleClose()
    await   fetchExperienceData()
      showAlert("success",json.msg)
   }
 }       
const onChange = (e) => {
  const {name , value} = e.target
  setFetchedData({...fetchedData, [name]:value})
}
  return (
    <div className=''>
   
   
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Experience</Modal.Title>
        </Modal.Header>
       <Modal.Body>
<Form>
<Form.Group className="mb-3" controlId="formBasicEmail">
<Form.Label>Job</Form.Label>
<Form.Control type="text" placeholder="job" name='ejob'onChange={onChange}  value ={fetchedData.ejob}   />
</Form.Group>

<Form.Group className="mb-3" controlId="formBasicEmail">
<Form.Label>Department</Form.Label>
<Form.Control type="text" placeholder="dept" name='edepartment'onChange={onChange}  value ={fetchedData.edepartment}   />
</Form.Group>

<Form.Group className="mb-3" controlId="formBasicPassword">
<Form.Label>Institute</Form.Label>
<Form.Control type="text" placeholder="institute"  name ='eInstitute'onChange={onChange} value ={fetchedData.eInstitute} />
</Form.Group>
 
<Form.Group className="mb-3" controlId="formBasicPassword">
<Form.Label> Date</Form.Label>
<Form.Control type="text" placeholder=""  name ='edate'onChange={onChange} value ={fetchedData.edate} />
</Form.Group>
</Form>
</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={ async()=> await handleUpdate()}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    <section className="text-gray-600 body-font overflow-hidden">
  <div className="container px-5 py-24 mx-auto">
    <div className="-my-8 divide-y-2 divide-gray-100">
    <div className=" text-3xl md:text-5xl  mb-4 md:mb-8 text-center font-extrabold ...">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-yellow-500 to-violet-500 mt-1   ">
            My Professional Experience
            </span>
          </div>
          {token && <>  <div className=" flex justify-center items-center  mx-auto">
            <button className="  bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-black py-2 px-4  border border-blue-500 hover:border-transparent rounded">
              <Link to="/addExperience" className="no-underline "> add new one</Link>

            </button>
          </div></>}
{ExperienceData.data && ExperienceData.data.map((item , i) => {

  return      <div key={i} className="py-8 flex flex-wrap md:flex-nowrap">
        <div className="md:w-64 md:mb-0 mb-6 flex-shrink-0 flex flex-col">

         {token  && <>
                            {" "}
                            <span
                              className="flex  py-1 px-2 rounded    text-xs font-medium tracking-widest"
                              style={{ userSelect: "auto" }}
                            >
                              {/* ❤😊   */}
                              
                              <FaRegEdit
                                 onClick={()=>handleEdit({id: item._id, job:item.job, department:item.department,institute:item.institute, date:item.date})}
                                className="mx-2 cursor-pointer"
                                size={20}
                              />

                              <RiDeleteBin5Line
                              onClick={async()=> await  handleDeleteExperience({id: item._id})}
                                className="cursor-pointer"
                                size={20}
                              />
                            </span>
                          </> }
          <span className="font-semibold title-font text-gray-700">
          {item.job} 
          </span>
         
          <span className="mt-1 text-gray-500 text-sm"> {item.date}</span>
        </div>
        <div className="md:flex-grow">
          <h2 className="text-2xl font-medium text-gray-900 title-font mb-2">
          {item.department}
          </h2>
          <p className="leading-relaxed">
              {item.institute}
          </p>
          
        </div>
      </div>
})}
   

 






      
    </div>
  </div>
</section>

    </div>
  )
}

export default Experience